"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("./SideBarMenu.css");
var SupportedFunction_1 = require("./SupportedFunction");
var react_router_dom_1 = require("react-router-dom");
var SideBarMenu = /** @class */ (function (_super) {
    __extends(SideBarMenu, _super);
    function SideBarMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.handlePage = _this.handlePage.bind(_this);
        return _this;
    }
    SideBarMenu.prototype.handlePage = function (val) {
        this.props.history.push(val);
    };
    SideBarMenu.prototype.render = function () {
        return (React.createElement(reactstrap_1.Nav, { className: "d-md-block sidebar" /*style={{ backgroundColor: "whitesmoke" }}*/ },
            React.createElement("div", null,
                React.createElement(SupportedFunction_1.default, { handlePage: this.handlePage }))));
    };
    return SideBarMenu;
}(React.Component));
exports.default = react_router_dom_1.withRouter(SideBarMenu);
//# sourceMappingURL=SideBarMenu.js.map